import styled from 'styled-components';
import Modal from '~~elements/Modal';
import Multilingual from '../Multilingual';
import moment from 'moment';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  text-align: start;
  .title {
    font-size: 0.9rem;
    font-weight: bold;
    margin: 1rem 0 0.5rem;
  }
  .content {
    font-size: 1rem;
    font-weight: normal;
    margin: 0.2rem 0;
    p {
      margin: 0;
    }
    span {
      margin-left: 0.3rem;
      font-size: 0.8rem;
    }
  }
  .line {
    width: 100%;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid gray;
  }
`;

const PluginOrderDetail = ({ pluginOrder, toClose }) => {
  return (
    <Modal.Modal isOpen={!!pluginOrder} onClickBack={toClose} outterClickBack={true}>
      <Modal.ModalHeader hasBack={true} onClickBack={toClose}>
        訂單內容
      </Modal.ModalHeader>
      <Modal.ModalBody>
        <StyledDiv>
          <h3 className="title">訂單編號</h3>
          <div className="content">{pluginOrder.uniqid}</div>
          <hr className="line" />
          <h3 className="title">狀態</h3>
          <div className="content">
            {Multilingual(`STATUS.${pluginOrder.status}`)}
            {pluginOrder.status === 'CREATED' && !!pluginOrder.paid_at && moment(pluginOrder.paid_at).isValid() && (
              <span>({moment(pluginOrder.paid_at).format('YYYY/MM/DD HH:mm')})</span>
            )}
          </div>
          <hr className="line" />
          <h3 className="title">金額</h3>
          <div className="content">{`NT$ ${new Intl.NumberFormat('zh-TW').format(pluginOrder.payment_amount)}`}</div>
          <hr className="line" />
          <h3 className="title">下單時間</h3>
          <div className="content">
            {!pluginOrder.created_at || !moment(pluginOrder.created_at).isValid()
              ? '-'
              : moment(pluginOrder.created_at).format('YYYY/MM/DD HH:mm')}
          </div>
          <hr className="line" />
          <h3 className="title">商品內容</h3>
          <div className="content">
            {pluginOrder.items.map((item, i) => (
              <p key={i}>
                {`${i + 1}. ${item.name} `}
                {`NT$ ${new Intl.NumberFormat('zh-TW').format(item.retail_price)} `}
                {`x${item.amount}`}
              </p>
            ))}
          </div>
          <hr className="line" />
          <h3 className="title">備註</h3>
          <div className="content">{!pluginOrder.comment ? '無' : pluginOrder.comment}</div>
          <h3 className="title">發票人</h3>
          <div className="content">
            <p>
              {pluginOrder.buyer_name}
              <span>({pluginOrder.buyer_phone})</span>
            </p>
            {pluginOrder.buyer_tel && <p>(${pluginOrder.buyer_tel})</p>}
            <p>{`${pluginOrder.buyer_city} ${pluginOrder.buyer_postcode} ${pluginOrder.buyer_street}`}</p>
          </div>
          <hr className="line" />
          <h3 className="title">發票資訊</h3>
          <div className="content">
            <p>{Multilingual(`RECEIPT_TYPE.${pluginOrder.receipt_type}`)}</p>
            <p>
              {pluginOrder.receipt_number}
              <span>
                (
                {!pluginOrder.receipt_created_at || !moment(pluginOrder.receipt_created_at).isValid()
                  ? '尚未開立'
                  : moment(pluginOrder.receipt_created_at).format('YYYY/MM/DD')}
                )
              </span>
            </p>
          </div>
        </StyledDiv>
      </Modal.ModalBody>
    </Modal.Modal>
  );
};

export default PluginOrderDetail;
